import React, { useContext, useState } from 'react';
import './SecondNavbar.css';
import { Link, Link as ScrollLink } from 'react-router-dom';
import { FaLongArrowAltUp } from 'react-icons/fa';
import { LanguageContext } from '../../../context/LanguageContext';
import { HiOutlineBars3, HiXMark } from 'react-icons/hi2';

const SecondNavbar = () => {
  const { texts } = useContext(LanguageContext);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleBackToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div className="second-navbar">
      {/* left links (desktop) */}
      <div className="secondNav-left">
        <ul>
            <ScrollLink
          to="experience"
          smooth={true}
          duration={600}
          offset={-80} 
          className="nav-link"
        >
          {texts.secondNavbar.experience}
        </ScrollLink>

        <ScrollLink
          to="capability"
          smooth={true}
          duration={600}
          offset={-80}
          className="nav-link"
        >
          {texts.secondNavbar.capability}
        </ScrollLink>

        <ScrollLink
          to="utility"
          smooth={true}
          duration={600}
          offset={-80}
          className="nav-link"
        >
          {texts.secondNavbar.utility}
        </ScrollLink>

        <ScrollLink
          to="accessories"
          smooth={true}
          duration={600}
          offset={-80}
          className="nav-link"
        >
          {texts.secondNavbar.accessories}
        </ScrollLink>

        <ScrollLink
          to="specifications"
          smooth={true}
          duration={600}
          offset={-80}
          className="nav-link"
        >
          {texts.secondNavbar.specifications}
        </ScrollLink>
        </ul>
      </div>

      {/* right buttons */}
      <div className="secondNav-right">
        <button className="btt flex1" onClick={handleBackToTop}>
          {texts.secondNavbar.backToTop} <FaLongArrowAltUp />
        </button>

        {/* burger menu icon */}
        <HiOutlineBars3
          className="burgerMenuNav2"
          size={30}
          color="#fff"
          onClick={() => setMenuOpen(true)}
        />
      </div>

      {/* mobile menu overlay */}
      {menuOpen && (
        <div className="mobileMenuNav2">
          <button className="closeMenuBtn" onClick={() => setMenuOpen(false)}>
            <HiXMark size={30} color="#fff" />
          </button>

          <div className="mobileLinks">
            <Link to="/" onClick={() => setMenuOpen(false)}>
              {texts.secondNavbar.experience}
            </Link>
            <Link to="/services" onClick={() => setMenuOpen(false)}>
              {texts.secondNavbar.capability}
            </Link>
            <Link to="/contact" onClick={() => setMenuOpen(false)}>
              {texts.secondNavbar.utility}
            </Link>
            <Link to="/contact" onClick={() => setMenuOpen(false)}>
              {texts.secondNavbar.accessories}
            </Link>
            <Link to="/contact" onClick={() => setMenuOpen(false)}>
              {texts.secondNavbar.specifications}
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default SecondNavbar;
